import { useCallback } from 'react';
import { collectCredentialErrors, pickChangedFieldErrors } from '../credentialV2Utils';

const validate = (cred) => {
  const errors = {};

  if (!cred?.data?.number?.credential_number) {
    errors.credential_number = 'Credential number is required';
  }
  if (!cred?.issued_at) {
    errors.issued_at = 'Issued date is required';
  }
  if (!cred?.expired_at) {
    errors.expired_at = 'Expiration date is required';
  }

  return errors;
};

const hasFieldChanged = (current, original, field) => {
  if (field === 'credential_number') {
    return (current?.data?.number?.credential_number ?? '') !== (original?.data?.number?.credential_number ?? '');
  }
  return (current?.[field] ?? '') !== (original?.[field] ?? '');
};

export const useCredentialNumber = () => {
  const getErrors = useCallback(
    (current, original) =>
      pickChangedFieldErrors(validate(current), current, original, hasFieldChanged),
    [],
  );

  const validateAll = useCallback(
    (credentials) => collectCredentialErrors(credentials, validate),
    [],
  );

  return { getErrors, validateAll };
};
